import {Injectable} from '@angular/core';
import {SelectServiceLib} from '../../../core/libraries/Dynamic-fields/components/select/classes/SelectServiceLib.service';

@Injectable()
export class SelectService extends SelectServiceLib {

}
